/* Shelters & Canopies header: sticky offset, live open/closed, mega menus, predictive search, mobile drawer. */
(function () {
  var root = document.querySelector('[data-sch]');
  if (!root || root.__on) return;
  root.__on = true;

  /* sticky: only the top bar scrolls away */
  var top = root.querySelector('.sch__top');
  function setTop() { document.documentElement.style.setProperty('--sch-top', (top ? top.offsetHeight : 0) + 'px'); }
  setTop(); window.addEventListener('resize', setTop);

  /* open / closed (UK time, Mon–Fri) */
  var st = root.querySelector('[data-sch-open]');
  if (st) {
    var o = (st.getAttribute('data-open') || '08:30').split(':'), c = (st.getAttribute('data-close') || '17:00').split(':');
    var oM = +o[0] * 60 + +o[1], cM = +c[0] * 60 + +c[1];
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {}
    var days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'], wd = parts.weekday, mins = (+parts.hour % 24) * 60 + +parts.minute;
    var open = days.indexOf(wd) > -1 && mins >= oM && mins < cM;
    var label;
    if (open) label = 'Open now · until ' + c.join(':');
    else if (days.indexOf(wd) > -1 && mins < oM) label = 'Closed · opens ' + o.join(':');
    else label = 'Closed · opens ' + (wd === 'Fri' || wd === 'Sat' || wd === 'Sun' ? 'Monday ' : 'tomorrow ') + o.join(':');
    if (parts.weekday) {
      st.querySelector('[data-t]').textContent = label;
      st.querySelector('.sch__dot').classList.toggle('on', open);
    }
  }

  /* mega menus */
  var items = root.querySelectorAll('[data-mega]'), timer;
  function close(except) {
    items.forEach(function (li) {
      if (li === except) return;
      var a = li.querySelector('a'), p = li.querySelector('.sch__mega');
      if (a) a.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    });
  }
  function openItem(li) {
    close(li);
    li.querySelector('a').setAttribute('aria-expanded', 'true');
    li.querySelector('.sch__mega').hidden = false;
  }
  items.forEach(function (li) {
    li.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { openItem(li); }, 120); });
    li.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { close(); }, 180); });
    li.querySelector('a').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); openItem(li); var f = li.querySelector('.sch__mega a'); if (f) f.focus(); }
    });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); hideSug(); } });

  /* predictive search */
  var form = root.querySelector('.sch__sf'), q = form && form.querySelector('input[name=q]'), sug = root.querySelector('[data-sch-sug]');
  var empty = sug && sug.querySelector('[data-empty]'), res = sug && sug.querySelector('[data-res]'), t2, last = '';
  function hideSug() { if (sug) { sug.hidden = true; q && q.setAttribute('aria-expanded', 'false'); } }
  function showSug() { sug.hidden = false; q.setAttribute('aria-expanded', 'true'); }
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  var money = function (v) { var n = parseFloat(v); return isNaN(n) ? '' : '£' + n.toLocaleString('en-GB', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
  function search(term) {
    if (term === last) return; last = term;
    if (term.length < 2) { res.innerHTML = ''; empty.hidden = false; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (term !== last) return;
        var R = (j.resources || {}).results || {}, ps = (R.products || []).filter(function (p) { return !/add-?on/i.test(p.type || '') && !/^shelter configuration options/i.test(p.title); }), cs = R.collections || [];
        var h = '';
        if (cs.length) h += '<p class="sch__sh">Ranges</p><div class="sch__cols">' + cs.slice(0, 5).map(function (c) { return '<a href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
        if (ps.length) h += '<p class="sch__sh">Products</p>' + ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<i></i>';
          var pr = (p.price_min && p.price_max && p.price_min !== p.price_max ? 'from ' : '') + money(p.price_min || p.price);
          return '<a class="sch__pr" role="option" href="' + p.url + '">' + img + '<span>' + esc(p.title) + '</span><b>' + pr + '</b></a>';
        }).join('');
        if (!h) h = '<p style="margin:6px 2px;color:#545B61">No match for “' + esc(term) + '”. Try a bike number (e.g. 20 bike) or a type (canopy, compound).</p>';
        h += '<a class="sch__all" href="' + form.action + '?q=' + encodeURIComponent(term) + '&type=product">See all results for “' + esc(term) + '” →</a>';
        empty.hidden = true; res.innerHTML = h;
      }).catch(function () {});
  }
  if (q && sug) {
    q.addEventListener('focus', function () { showSug(); });
    q.addEventListener('input', function () { clearTimeout(t2); var v = q.value.trim(); t2 = setTimeout(function () { search(v); }, 180); showSug(); });
    q.addEventListener('keydown', function (e) {
      var links = [].slice.call(res.querySelectorAll('.sch__pr')); if (!links.length) return;
      var i = links.findIndex(function (a) { return a.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (i > -1) links[i].removeAttribute('aria-selected');
        i = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : Math.max(0, i - 1);
        links[i].setAttribute('aria-selected', 'true');
      } else if (e.key === 'Enter' && i > -1) { e.preventDefault(); location.href = links[i].href; }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.sch__s')) hideSug(); });
  }

  /* mobile drawer */
  var dr = root.querySelector('[data-sch-dr]'), burger = root.querySelector('[data-sch-burger]');
  function drawer(on) {
    if (!dr) return;
    dr.hidden = !on; burger.setAttribute('aria-expanded', String(on));
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (on) { var b = dr.querySelector('button'); b && b.focus(); }
  }
  if (burger) burger.addEventListener('click', function () { drawer(true); });
  if (dr) dr.addEventListener('click', function (e) { if (e.target.closest('[data-sch-x]')) drawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });
})();